export default function Policy() {
    const selectors = {
        'tabs': '.policy-tab-tabs',
        'tab': '.policy-tab-name',
        'contentWrapper': '.policy-tab-wrapper',
        'content': '.policy-tab-content'
    };

    this.init = () => {
        this.handle();
    };

    this.move2Tab = ($tab, $parent) => {
        $parent.find(`${selectors.content}[data-tab="${$tab}"]`).removeClass('lg:hidden').siblings().addClass('lg:hidden');
    }

    this.handle = () => {
        jQuery(selectors.tabs).on('click', selectors.tab, (e) => {
            e.preventDefault();
            const $this = jQuery(e.currentTarget);
            let $tab = $this.data("tab");
            let $parent = $this.closest(selectors.tabs);
            $this.addClass('active').siblings().removeClass('active');
            this.move2Tab($tab, $parent);
        })
    }
}